import { BOXERS } from "../data/boxers";

function Select({
    onChooseBoxer,
    boxers = BOXERS,
    onHoverFighterCard,
    onSelectFighterCard
}) {
    const roster = boxers || BOXERS;

    return (
        <section className="screen screen-select">
            <div>
                <h2>Choose Your Boxer</h2>
                <p className="select-instruction">Select your fighter for this career run.</p>

                <div className="select-grid">
                    <button
                        type="button"
                        className="fighter-card fighter-card--male"
                        onMouseEnter={() => onHoverFighterCard?.()}
                        onClick={() => {
                            onSelectFighterCard?.();
                            onChooseBoxer("male");
                        }}
                    >
                        <div className="fighter-card__content">
                            <span className="fighter-card__name">{roster.male?.name || BOXERS.male.name}</span>
                            <span className="fighter-card__style">Male • {roster.male?.description || BOXERS.male.description}</span>
                        </div>
                    </button>

                    <button
                        type="button"
                        className="fighter-card fighter-card--female"
                        disabled
                        onMouseEnter={() => onHoverFighterCard?.()}
                        onClick={() => {
                            onSelectFighterCard?.();
                            onChooseBoxer("female");
                        }}
                    >
                        <div className="fighter-card__content">
                            <span className="fighter-card__name">{roster.female?.name || BOXERS.female.name}</span>
                            <span className="fighter-card__style">Female • {roster.female?.description || BOXERS.female.description}</span>
                        </div>
                    </button>
                </div>
            </div>
        </section>
    );
}

export default Select;
